import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styles from './cards.scss'
import classNames from 'classnames'
import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'
import { MANEUVERS_TITLE, MANEUVERS_DESCRIPTION } from '../translations'



const ManeuversCard = memo(({ withNews, withQuests, wgshEventsUrl }) => {
    const withOnlyNews = withNews && !withQuests
    const withOnlyQuests = !withNews && withQuests
    const withNewsWithQuests = withNews && withQuests

    const classes = classNames(
        styles.card,
        styles.maneuvers,
        withOnlyNews && styles.maneuvers__with_news,
        withOnlyQuests && styles.maneuvers__with_quests,
        withNewsWithQuests && styles.maneuvers__with_news_with_quests
        )

    const handleClick = () => {
        window.location = wgshEventsUrl
    }

    return (
        <div
            onClick={handleClick}
            onMouseDown={sendClickSoundCommand}
            onMouseEnter={sendHoverSoundCommand}
            className={classes}
        >
            <h2>{MANEUVERS_TITLE}</h2>
            <h3>{MANEUVERS_DESCRIPTION}</h3>
        </div>
    )
})

ManeuversCard.propTypes = {
    withNews: PropTypes.bool.isRequired,
    withQuests: PropTypes.bool.isRequired,
    wgshEventsUrl: PropTypes.string.isRequired,
}

export default ManeuversCard



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ManeuversCard.jsx